export function ScrollTo() {
    document.addEventListener('DOMContentLoaded', () => {
        const triggers = document.querySelectorAll('[data-scroll-to]');
        if (!triggers.length) return;

        const getHeaderHeight = () => {
            const raw = getComputedStyle(document.documentElement)
                .getPropertyValue('--header-height')
                .trim();

            if (!raw) return 0;

            if (raw.endsWith('rem')) {
                const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
                return parseFloat(raw) * rootFontSize;
            }
            return parseFloat(raw) || 0;
        };

        const resolveTarget = (trigger) => {
            const selector = trigger.dataset.scrollTo;
            if (selector) {
                return document.querySelector(selector);
            }
            const parentSection = trigger.closest('section');
            if (!parentSection) return null;

            // Globalna lista zamiast siblings — działa też gdy parentSection jest
            // opakowana w jakiś wrapper (np. ScrollTrigger pinSpacer), gdzie nie ma
            // siblingu na tym samym poziomie DOM.
            const allSections = Array.from(document.querySelectorAll('section'));
            const currentIndex = allSections.indexOf(parentSection);
            if (currentIndex === -1) return null;

            // Pomijamy zagnieżdżone sekcje (dzieci current), szukamy następnej w document order
            for (let i = currentIndex + 1; i < allSections.length; i++) {
                if (!parentSection.contains(allSections[i])) return allSections[i];
            }
            return null;
        };

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                const target = resolveTarget(trigger);
                if (!target) return;

                event.preventDefault();

                const targetTop = target.getBoundingClientRect().top + window.scrollY;
                // scroll w dół → header się chowa (SmartHeader), więc bez offsetu;
                // scroll w górę → header widoczny, odejmujemy jego wysokość
                const offset = targetTop > window.scrollY ? 0 : getHeaderHeight();

                window.scrollTo({ top: targetTop - offset, behavior: 'smooth' });
            });
        });
    });
}
